import vInputDate from './InputDate.vue';

export { vInputDate };



// WEBPACK FOOTER //
// ./src/baseComponents/components/InputDate/index.js